import comp from '../components/barrel';
import svg from '../js/svg';
import U from '../js/utils';
import config from '../js/config';
import listReturnState from '../js/listReturnState';

let appListfilters = {};
let appListTimeout = null; // Add this for debouncing
let navListFilter = null; // 'flagged' | 'recent'

export default {
  async prepare() {
    const vars = {};
    vars.filters = {};
    const listRestore = this.vars && this.vars.listRestore;
    if (listRestore && listRestore.filters) {
      const appListVars = {
        filters: {...listRestore.filters},
        page: listRestore.selected_page || 1,
        limit: 50,
      };
      this.vars.selected_page = listRestore.selected_page || 1;
      this.recipe.methods.push(await O.mPOST('application/app-list', appListVars));
    } else {
      const navFilter = this.vars && this.vars.nav_filter;
      if (navFilter === 'flagged' || navFilter === 'recent') {
        navListFilter = navFilter;
        this.vars.selected_page = 1;
        const appListVars = await this.buildNavFilterAppListVars(navFilter);
        this.recipe.methods.push(await O.mPOST('application/app-list', appListVars));
      } else {
        const cookieResult = await O.getCookie('xyndfltopn');
        const defaultOpenYn = cookieResult?.value;
        const defaultOpen = defaultOpenYn === 'Y' || defaultOpenYn === true || defaultOpenYn === 'true';
        const openFromNav =
          this.vars &&
          (this.vars.openApplicationsYN === true ||
            this.vars.openApplicationsYN === 'true' ||
            this.vars.openApplicationsYN === 1);
        vars.filters.openApplicationsYN = openFromNav ? true : defaultOpen;
        const ribbonWill = this.vars && this.vars.will_filter != null ? String(this.vars.will_filter).trim() : '';
        if (ribbonWill) {
          vars.filters.will_filter = ribbonWill;
        }
        this.recipe.methods.push(await O.mPOST('application/app-list', vars));
      }
    }
    this.recipe.methods.push(await O.mPOST('communal/divisions', vars));
    this.recipe.methods.push(await O.mPOST('communal/div-branches', vars));
    this.recipe.methods.push(await O.mPOST('communal/app_status', vars));
  },

  async render() {
    const rec = this.recipe.methods;
    let data = {};
    if (rec.length) {
      data = await O.PREP(rec);
    }
    await this.loadPage(data);
  },

  async loadPage(data) {
    const listReturn = this.vars && this.vars.listRestore;
    const cookieResult = await O.getCookie('xyndfltopn');
    const defaultOpenYn = cookieResult?.value;
    const defaultOpen = defaultOpenYn === 'Y' || defaultOpenYn === true || defaultOpenYn === 'true';
    if (!listReturn) {
      // Defer so we run after core has moved HTML from shadowDiv to mainContent (innerHTML copy drops .checked)
      setTimeout(() => {
        const openCheckbox = U.id('openApplicationsCheckbox');
        const openFromNav =
          this.vars &&
          (this.vars.openApplicationsYN === true ||
            this.vars.openApplicationsYN === 'true' ||
            this.vars.openApplicationsYN === 1);
        if (openCheckbox) openCheckbox.checked = openFromNav ? true : defaultOpen;
        const willEl = U.id('willNumberSearch');
        const navEl = U.id('navRibbonInput');
        const ribbonWill = this.vars && this.vars.will_filter != null ? String(this.vars.will_filter).trim() : '';
        if (ribbonWill) {
          if (willEl) willEl.value = ribbonWill;
          if (navEl) navEl.value = ribbonWill;
        } else if (willEl && navEl) {
          navEl.value = willEl.value;
        }
        if (typeof window.updateNavRibbonClearBtn === 'function') window.updateNavRibbonClearBtn();
        this.updateNavRibbonFilterButtons();
      }, 0);
    } else {
      setTimeout(() => {
        if (typeof window.updateNavRibbonClearBtn === 'function') window.updateNavRibbonClearBtn();
        this.updateNavRibbonFilterButtons();
      }, 0);
    }

    // Clear filters button
    U.id('mainContent').addEventListener('click', (e) => {
      if (e.target.id === 'clearFilters') {
        this.getAppList(true);
      }
    });

    // Add event delegation for dropdown changes
    document.addEventListener('change', (e) => {
      if (e.target.id === 'statusDD') {
        // If status is selected, uncheck the checkbox
        const statusValue = e.target.value;
        const checkboxEl = U.id('openApplicationsCheckbox');
        if (statusValue && statusValue !== '' && checkboxEl) {
          checkboxEl.checked = false;
        }
        this.debouncedGetAppList(); // Use debounced version
      } else if (e.target.id === 'companyDD' || e.target.id === 'companyBranchDD' || e.target.id === 'openApplicationsCheckbox') {
        this.debouncedGetAppList(); // Use debounced version
      }
    });

    // Add mousedown event listener to document body to remove suggestion dropdown
    document.addEventListener('mousedown', (e) => {
      // Reference dropdown of suggested list item
      let suggestionItemParent = e.target.parentNode;
      // Organisation auto-suggest
      let orgListDropdownEl = U.id('orgListDropdownContainer');
      if (orgListDropdownEl && e.target !== orgListDropdownEl && suggestionItemParent.id !== 'orgListDropdown') {
        orgListDropdownEl.remove();
      }

      // Organisation Branch auto-suggest
      let orgBranchListDropdownEl = U.id('orgBranchListDropdownContainer');
      if (orgBranchListDropdownEl && e.target !== orgBranchListDropdownEl && suggestionItemParent.id !== 'orgBranchListDropdown') {
        orgBranchListDropdownEl.remove();
      }

      // Advisor auto-suggest
      let advisorDropdownEl = U.id('advisorListDropdownContainer');
      if (advisorDropdownEl && e.target !== advisorDropdownEl && suggestionItemParent.id !== 'advisorListDropdown') {
        advisorDropdownEl.remove();
      }
    });

    // Build Table Head - WAIT for it to complete
    await this.buildTableHead(data);

    if (listReturn) {
      this.applyListReturnToDom(listReturn);
      delete this.vars.listRestore;
    }

    // Build Table Body
    const listData = data[`application/app-list`];
    const appListData = listData.data;
    await this.buildTableBody(appListData);
    // Set state to current page then call function responsible for building pagination
    const paginationState = listData.pagination;
    thsPage.vars.selected_page = paginationState.current_page;
    this.buildPaginationButtons(paginationState);
    this.updatePaginationInfo(paginationState);
    
    // Set up the search input events after everything is rendered
    this.setupSearchInputEvents();
  },

  captureListReturnState() {
    const filters = {};
    const genSearchEl = U.id('genSearch');
    filters.search_filters = genSearchEl ? genSearchEl.value.trim() : '';
    const willNumberSearchEl = U.id('willNumberSearch');
    filters.will_filter = willNumberSearchEl ? willNumberSearchEl.value.trim() : '';
    const companyDDEl = U.id('companyDD');
    filters.company = companyDDEl ? companyDDEl.value : '';
    const companyBranchDDEl = U.id('companyBranchDD');
    filters.company_branch = companyBranchDDEl ? companyBranchDDEl.value : '';
    if (thsPage.vars.organisation) {
      filters.organisation = thsPage.vars.organisation;
    } else {
      filters.organisation = '';
    }
    if (thsPage.vars.organisation_branch) {
      filters.organisation_branch = thsPage.vars.organisation_branch;
    } else {
      filters.organisation_branch = '';
    }
    const statusDDEl = U.id('statusDD');
    filters.status = statusDDEl ? statusDDEl.value : '';
    if (thsPage.vars.advisor) {
      filters.advisor = thsPage.vars.advisor;
    } else {
      filters.advisor = '';
    }
    const statusValue = statusDDEl ? statusDDEl.value : '';
    if (statusValue && statusValue !== '') {
      filters.openApplicationsYN = false;
    } else {
      const checkboxEl = U.id('openApplicationsCheckbox');
      filters.openApplicationsYN = checkboxEl ? checkboxEl.checked : true;
    }
    const page = thsPage.vars.selected_page
      ? parseInt(String(thsPage.vars.selected_page), 10) || 1
      : 1;
    const suggest = {
      organisation: thsPage.vars.organisation || '',
      organisation_text: thsPage.vars.organisation_text || '',
      organisation_branch: thsPage.vars.organisation_branch || '',
      organisation_branch_text: thsPage.vars.organisation_branch_text || '',
      advisor: thsPage.vars.advisor || '',
      advisor_text: thsPage.vars.advisor_text || '',
    };
    return {filters, selected_page: page, suggest};
  },

  applyListReturnToDom(lr) {
    if (!lr || !lr.filters) return;
    const f = lr.filters;
    appListfilters = {...f};
    thsPage.vars.organisation = (lr.suggest && lr.suggest.organisation) || '';
    thsPage.vars.organisation_text = (lr.suggest && lr.suggest.organisation_text) || '';
    thsPage.vars.organisation_branch = (lr.suggest && lr.suggest.organisation_branch) || '';
    thsPage.vars.organisation_branch_text = (lr.suggest && lr.suggest.organisation_branch_text) || '';
    thsPage.vars.advisor = (lr.suggest && lr.suggest.advisor) || '';
    thsPage.vars.advisor_text = (lr.suggest && lr.suggest.advisor_text) || '';
    const genSearchEl = U.id('genSearch');
    if (genSearchEl) genSearchEl.value = f.search_filters != null ? f.search_filters : '';
    const willNumberSearchEl = U.id('willNumberSearch');
    if (willNumberSearchEl) willNumberSearchEl.value = f.will_filter != null ? f.will_filter : '';
    const navEl = U.id('navRibbonInput');
    if (navEl) navEl.value = f.will_filter != null ? f.will_filter : '';
    const companyDDEl = U.id('companyDD');
    if (companyDDEl) companyDDEl.value = f.company != null ? f.company : '';
    const companyBranchDDEl = U.id('companyBranchDD');
    if (companyBranchDDEl) companyBranchDDEl.value = f.company_branch != null ? f.company_branch : '';
    const statusDDEl = U.id('statusDD');
    if (statusDDEl) statusDDEl.value = f.status != null ? f.status : '';
    const openChk = U.id('openApplicationsCheckbox');
    if (openChk) openChk.checked = !!f.openApplicationsYN;
    const orgI = U.id('organisationDD');
    if (orgI) orgI.value = thsPage.vars.organisation_text || '';
    const orgBrI = U.id('organisationBranchDD');
    if (orgBrI) orgBrI.value = thsPage.vars.organisation_branch_text || '';
    const advI = U.id('advisorDD');
    if (advI) advI.value = thsPage.vars.advisor_text || '';
  },

  // Add this new debounced function
  debouncedGetAppList() {
    clearTimeout(appListTimeout);
    appListTimeout = setTimeout(() => {
      this.getAppList();
    }, 500); // 500ms delay
  },

  updateNavRibbonFilterButtons() {
    const flaggedBtn = U.id('navRibbonFlaggedBtn');
    const recentBtn = U.id('navRibbonRecentBtn');
    if (flaggedBtn) flaggedBtn.classList.toggle('nav-ribbon-filter-active', navListFilter === 'flagged');
    if (recentBtn) recentBtn.classList.toggle('nav-ribbon-filter-active', navListFilter === 'recent');
  },

  clearNavListFilter() {
    navListFilter = null;
    this.updateNavRibbonFilterButtons();
  },

  setNavListFilter(mode) {
    navListFilter = mode;
    this.updateNavRibbonFilterButtons();
  },

  async buildNavFilterAppListVars(mode, page) {
    if (mode === 'flagged') {
      return {
        flagged_applications: true,
        page: page || 1,
        limit: 50,
      };
    }
    if (mode === 'recent') {
      const hdrs = await O.getAuthHdrs();
      return {
        user_uuid: hdrs.user_uuid || '',
        recent_views: true,
      };
    }
    return null;
  },

  async fetchAndRenderAppList(vars) {
    const res = await O.PREP([await O.mPOST('application/app-list', vars)]);
    const listData = res['application/app-list'];
    const appListData = listData.data;
    const paginationState = listData.pagination;

    await this.buildTableBody(appListData);
    this.buildPaginationButtons(paginationState);
    this.updatePaginationInfo(paginationState);
    thsPage.vars.selected_page = paginationState.current_page;
  },

  async applyNavListFilter(mode) {
    this.setNavListFilter(mode);
    thsPage.vars.selected_page = 1;
    const vars = await this.buildNavFilterAppListVars(mode, 1);
    if (!vars) return;

    try {
      await this.fetchAndRenderAppList(vars);
    } catch (error) {
    }
  },

  clearPendingFlagRemoval() {
    this._flagRemovalEl = null;
  },

  async promptRemoveApplicationViewFlag(logApplicationViewUuid, flagEl) {
    this._flagRemovalEl = flagEl;
    await comp.modal(
      'Remove flag',
      'Are you sure you want to remove this flag?',
      `thsPage.removeApplicationViewFlag('${logApplicationViewUuid}')`,
      'thsPage.clearPendingFlagRemoval()'
    );
  },

  async removeApplicationViewFlag(logApplicationViewUuid) {
    const vars = {
      log_application_view_uuid: logApplicationViewUuid,
      true_false: false,
    };

    try {
      await O.PREP([await O.mPOST('application/upd-application-view-flag', vars)]);
      if (this._flagRemovalEl) {
        this._flagRemovalEl.remove();
        this._flagRemovalEl = null;
      }
    } catch (error) {
      this._flagRemovalEl = null;
      comp.errorBox('Error', 'Failed to remove flag. Please try again.');
    }
  },

  async buildTableHead(data) {
    const companyDDdata = data['communal/divisions']?.data?.divisions || [];
    const companyBranchDDdata = await data[`communal/div-branches`].data;
    const statusDDdata = await data[`communal/app_status`].data;

    // Create table header row
    const appTableHead = U.id('appTableHead');
    appTableHead.innerHTML = '';
    const headRow = appTableHead.insertRow();

    // Creation of header elements and their appendments to DOM

    //Action - Link to navigate to detail page
    headRow.insertCell(0);

    const flaggedHead = headRow.insertCell(1);
    flaggedHead.innerHTML = '&nbsp;';
    flaggedHead.style.textAlign = 'center';

    // Party 1 static heading
    const party1 = headRow.insertCell(2);
    party1.innerHTML = 'Party 1';

    // Party 2 static heading
    const party2 = headRow.insertCell(3);
    party2.innerHTML = 'Party 2';

    // Status of will selection dropdown - CHANGED: use application_status_uuid as value
    const status = headRow.insertCell(4);
    let statusDD = await comp.selectThead('statusDD', statusDDdata, 'application_status_uuid', 'short_text', '', 'Status');
    status.appendChild(statusDD);

    const willNumberHead = headRow.insertCell(5);
    willNumberHead.innerHTML = 'Will number';

    // Icons column - no heading
    const icons = headRow.insertCell(6);
    icons.innerHTML = '&nbsp;';

    // Advisor auto-suggest text input element - Remove oninput parameter
    const advisor = headRow.insertCell(7);
    let advisorDD = await comp.inputText('advisorDD', '', '', 0, '', 'Advisors', true);
    advisor.appendChild(advisorDD);

    // Date of will creation static heading
    const sourceRef = headRow.insertCell(8);
    sourceRef.innerHTML = 'Date Created';

    // Application type static heading
    const appType = headRow.insertCell(9);
    appType.innerHTML = 'App Type';

    // Organisation auto-suggest text input element - Remove oninput parameter
    const organisation = headRow.insertCell(10);
    let organisationDD = await comp.inputText('organisationDD', '', '', 0, '', 'Org.', true);
    organisation.appendChild(organisationDD);

    // Organisation branch auto-suggest text input element - Remove oninput parameter
    const organisationBranch = headRow.insertCell(11);
    let organisationBranchDD = await comp.inputText('organisationBranchDD', '', '', 0, '', 'Org. branch', true);
    organisationBranch.appendChild(organisationBranchDD);

    // Company selection dropdown
    const company = headRow.insertCell(12);
    if (companyDDdata.length) {
      let companyDD = await comp.selectThead('companyDD', companyDDdata, 'division_uuid', 'short_text', '', 'Company');
      company.appendChild(companyDD);
    } else {
      company.innerHTML = '<span>No companies available</span>';
    }

    // Company branch selection dropdown
    const companyBranch = headRow.insertCell(13);
    let companyBranchDD = await comp.selectThead('companyBranchDD', companyBranchDDdata, 'division_branch_uuid', 'short_text', '', 'Company Branch');
    companyBranch.appendChild(companyBranchDD);
  },

  async buildTableBody(appListData) {
    let appTableBody = U.id('appTableBody');
    appTableBody.innerHTML = '';

    if (appListData.length) {
      for (const row of appListData) {
        const appRow = appTableBody.insertRow();

        const editApp = appRow.insertCell(0);
        const linkSVG = svg.linkNewPage();
        linkSVG.style.cursor = 'pointer';
        linkSVG.setAttribute('role', 'button');
        linkSVG.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          listReturnState.save('ViewApplication', {
            listPage: 'ManageApplications',
            state: this.captureListReturnState(),
          });
          O.PREP('ViewApplication', `application_uuid=${row.application_uuid}`);
        });
        editApp.appendChild(linkSVG);

        const flaggedCell = appRow.insertCell(1);
        flaggedCell.style.textAlign = 'center';
        const viewUuid = row.log_application_view_uuid;
        const isFlagged =
          row.flagged_yn === true || row.flagged_yn === 'true' || row.flagged_yn === 1;
        if (isFlagged) {
          const flagIcon = svg.flag();
          flagIcon.classList.add('text-primary');
          flagIcon.style.cursor = 'pointer';
          flagIcon.title = 'Remove flag';
          flagIcon.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            const postUuid =
              viewUuid != null && String(viewUuid).trim() !== '' ? String(viewUuid).trim() : '';
            this.promptRemoveApplicationViewFlag(postUuid, flagIcon);
          });
          flaggedCell.appendChild(flagIcon);
        }

        const party1_names = appRow.insertCell(2);
        party1_names.innerHTML = row.party1_names;

        const party2_names = appRow.insertCell(3);
        party2_names.innerHTML = row.party2_names;

        const status = appRow.insertCell(4);
        const tag = await comp.statusTag(row.status);
        status.appendChild(tag);

        const willNumberCell = appRow.insertCell(5);
        const willNum = row.importwillnumber;
        willNumberCell.innerHTML =
          willNum !== undefined && willNum !== null && willNum !== '' ? String(willNum) : '';

        // Icons column - display blue circles with D and/or P
        const icons = appRow.insertCell(6);
        icons.style.textAlign = 'center';
        
        const iconsContainer = document.createElement('div');
        iconsContainer.style.display = 'flex';
        iconsContainer.style.gap = '4px';
        iconsContainer.style.justifyContent = 'center';
        iconsContainer.style.alignItems = 'center';
        
        // Check for final_discount_yn (handle both boolean and string values)
        if (row.final_discount_yn === true || row.final_discount_yn === 'true' || row.final_discount_yn === 1) {
          const dCircle = document.createElement('div');
          dCircle.style.width = '20px';
          dCircle.style.height = '20px';
          dCircle.style.borderRadius = '50%';
          dCircle.style.backgroundColor = '#3b82f6'; // blue-500
          dCircle.style.color = 'white';
          dCircle.style.display = 'flex';
          dCircle.style.alignItems = 'center';
          dCircle.style.justifyContent = 'center';
          dCircle.style.fontSize = '12px';
          dCircle.style.fontWeight = 'bold';
          dCircle.style.cursor = 'help';
          dCircle.textContent = 'D';
          dCircle.title = 'Discount recorded';
          iconsContainer.appendChild(dCircle);
        }
        
        // Check for has_products_yn (handle both boolean and string values)
        if (row.has_products_yn === true || row.has_products_yn === 'true' || row.has_products_yn === 1) {
          const pCircle = document.createElement('div');
          pCircle.style.width = '20px';
          pCircle.style.height = '20px';
          pCircle.style.borderRadius = '50%';
          pCircle.style.backgroundColor = '#3b82f6'; // blue-500
          pCircle.style.color = 'white';
          pCircle.style.display = 'flex';
          pCircle.style.alignItems = 'center';
          pCircle.style.justifyContent = 'center';
          pCircle.style.fontSize = '12px';
          pCircle.style.fontWeight = 'bold';
          pCircle.style.cursor = 'help';
          pCircle.textContent = 'P';
          pCircle.title = 'Products linked';
          iconsContainer.appendChild(pCircle);
        }
        
        icons.appendChild(iconsContainer);

        const advisor = appRow.insertCell(7);
        advisor.innerHTML = row.advisor;

        const created_date = appRow.insertCell(8);
        created_date.innerHTML = await U.formatDate(row.created_date);

        const will_type = appRow.insertCell(9);
        will_type.innerHTML = row.app_type;

        const organisation = appRow.insertCell(10);
        organisation.innerHTML = row.organisation;

        const organisationBranch = appRow.insertCell(11);
        organisationBranch.innerHTML = row.organisation_branch;

        const company = appRow.insertCell(12);
        company.innerHTML = row.company;

        const companyBranch = appRow.insertCell(13);
        companyBranch.innerHTML = row.company_branch;
      }
    } else {
      // No Applications
      const appRow = appTableBody.insertRow();
      const company = appRow.insertCell(0);
      company.innerHTML = 'No applications available.';
      company.colSpan = 14;
    }
  },

  async buildPaginationButtons(paginationState) {
    // Render pagination button elements inside a pagination wrapper div
    await comp.paginationButtons({totalPages: paginationState.total_pages, wrapperID: 'appPaginationWrapper'});
    // Once buttons are rendered then attach click event to each one
    const pageButtons = document.querySelectorAll('.pageButton');
    pageButtons.forEach((button) => {
      button.addEventListener('click', (e) => {
        // Set the pagination payload to match newly selected page
        thsPage.vars.selected_page = Number(e.target.getAttribute('value'));
        this.getAppList(false, true);
      });
    });
    
    // Update pagination info at bottom
    this.updatePaginationInfo(paginationState);
  },

  updatePaginationInfo(paginationState) {
    // Update top pagination info
    const totalRecordsTop = U.id('totalRecordsDisplay');
    const totalPagesTop = U.id('totalPagesDisplay');
    if (totalRecordsTop) {
      totalRecordsTop.textContent = paginationState.total_records || '-';
    }
    if (totalPagesTop) {
      totalPagesTop.textContent = paginationState.total_pages || '-';
    }
    
    // Update bottom pagination info
    const totalRecordsBottom = U.id('totalRecordsDisplayBottom');
    const totalPagesBottom = U.id('totalPagesDisplayBottom');
    if (totalRecordsBottom) {
      totalRecordsBottom.textContent = paginationState.total_records || '-';
    }
    if (totalPagesBottom) {
      totalPagesBottom.textContent = paginationState.total_pages || '-';
    }
  },

  async getAppList(filtersCleared, fromPagination) {
    if (navListFilter && fromPagination) {
      const page = parseInt(thsPage.vars.selected_page, 10) || 1;
      const vars = await this.buildNavFilterAppListVars(navListFilter, page);
      if (!vars) return;

      setTimeout(async () => {
        try {
          await this.fetchAndRenderAppList(vars);
        } catch (error) {
        }
      }, 500);
      return;
    }

    if (!filtersCleared) {
      this.clearNavListFilter();
      // General search text input value
      const genSearchEl = U.id('genSearch');
      appListfilters.search_filters = genSearchEl ? genSearchEl.value.trim() : '';
      // Will number search text input value
      const willNumberSearchEl = U.id('willNumberSearch');
      appListfilters.will_filter = willNumberSearchEl ? willNumberSearchEl.value.trim() : '';
      // Company dropdown search value
      const companyDDEl = U.id('companyDD');
      appListfilters.company = companyDDEl ? companyDDEl.value : '';
      // Company branch dropdown search value
      const companyBranchDDEl = U.id('companyBranchDD');
      appListfilters.company_branch = companyBranchDDEl ? companyBranchDDEl.value : '';
      
      // Organisation auto-suggest dropdown list value - FIXED LOGIC
      if (thsPage.vars.organisation) {
        // Use the org_uuid from the selected suggestion
        appListfilters.organisation = thsPage.vars.organisation;
      } else {
        // No organisation selected from suggestions
        appListfilters.organisation = '';
      }
      
      // Organisation branch auto-suggest dropdown list value - FIXED LOGIC
      if (thsPage.vars.organisation_branch) {
        appListfilters.organisation_branch = thsPage.vars.organisation_branch;
      } else {
        appListfilters.organisation_branch = '';
      }
      
      // Status dropdown search value
      const statusDDEl = U.id('statusDD');
      appListfilters.status = statusDDEl ? statusDDEl.value : '';
      
      // Advisor auto-suggest dropdown list value - FIXED LOGIC
      if (thsPage.vars.advisor) {
        // Use the user_uuid from the selected suggestion
        appListfilters.advisor = thsPage.vars.advisor;
      } else {
        // No advisor selected from suggestions
        appListfilters.advisor = '';
      }
      
      // Get checkbox state - if status is selected, set to false, otherwise use checkbox state
      const statusValue = statusDDEl ? statusDDEl.value : '';
      if (statusValue && statusValue !== '') {
        appListfilters.openApplicationsYN = false;
      } else {
        const checkboxEl = U.id('openApplicationsCheckbox');
        appListfilters.openApplicationsYN = checkboxEl ? checkboxEl.checked : true;
      }
    } else {
      // General search text input value
      const genSearchEl = U.id('genSearch');
      if (genSearchEl) genSearchEl.value = '';
      // Will number search text input value
      const willNumberSearchEl = U.id('willNumberSearch');
      if (willNumberSearchEl) willNumberSearchEl.value = '';
      const navRibbonEl = U.id('navRibbonInput');
      if (navRibbonEl) navRibbonEl.value = '';
      if (typeof window.updateNavRibbonClearBtn === 'function') window.updateNavRibbonClearBtn();
      // Company dropdown search value
      const companyDDEl = U.id('companyDD');
      if (companyDDEl) companyDDEl.value = '';
      // Company branch dropdown search value
      const companyBranchDDEl = U.id('companyBranchDD');
      if (companyBranchDDEl) companyBranchDDEl.value = '';
      // Organisation auto-suggest dropdown list value
      const organisationDDEl = U.id('organisationDD');
      if (organisationDDEl) organisationDDEl.value = '';
      // Organisation branch auto-suggest dropdown list value
      const organisationBranchDDEl = U.id('organisationBranchDD');
      if (organisationBranchDDEl) organisationBranchDDEl.value = '';
      // Status dropdown search value
      const statusDDEl = U.id('statusDD');
      if (statusDDEl) statusDDEl.value = '';
      // Advisor auto-suggest dropdown list value
      const advisorDDEl = U.id('advisorDD');
      if (advisorDDEl) advisorDDEl.value = '';
      // Reset checkbox to default (checked)
      const checkboxEl = U.id('openApplicationsCheckbox');
      if (checkboxEl) {
        checkboxEl.checked = true;
      }
      // Clear stored values
      thsPage.vars.organisation = '';
      thsPage.vars.organisation_text = '';
      thsPage.vars.organisation_branch = '';
      thsPage.vars.organisation_branch_text = '';
      thsPage.vars.advisor = '';
      thsPage.vars.advisor_text = '';
      // Clear filters to send in request
      appListfilters = {};
      // Reset checkbox filter to default (true)
      appListfilters.openApplicationsYN = true;
      this.clearNavListFilter();
    }


    // Set values of filter keys for app-list request to render filtered applications
    setTimeout(async () => {
      const vars = {};
      vars.filters = appListfilters;
      vars.limit = 50; // Changed from 10 to 50
      vars.page = parseInt(thsPage.vars.selected_page);

      try {
        await this.fetchAndRenderAppList(vars);
      } catch (error) {
      }
    }, 500);
  },

  async exportApplications(exportType) {
    // Get current filters (same logic as getAppList)
    const currentFilters = {};
    
    // General search text input value
    currentFilters.search_filters = U.id('genSearch').value.trim();
    // Will number search text input value
    const willNumberSearchEl = U.id('willNumberSearch');
    currentFilters.will_filter = willNumberSearchEl ? willNumberSearchEl.value.trim() : '';
    // Company dropdown search value
    currentFilters.company = U.id('companyDD').value;
    // Company branch dropdown search value
    currentFilters.company_branch = U.id('companyBranchDD').value;
    
    // Organisation auto-suggest dropdown list value
    if (thsPage.vars.organisation) {
      currentFilters.organisation = thsPage.vars.organisation;
    } else {
      currentFilters.organisation = '';
    }
    
    // Organisation branch auto-suggest dropdown list value
    if (thsPage.vars.organisation_branch) {
      currentFilters.organisation_branch = thsPage.vars.organisation_branch;
    } else {
      currentFilters.organisation_branch = '';
    }
    
    // Status dropdown search value
    currentFilters.status = U.id('statusDD').value;
    
    // Advisor auto-suggest dropdown list value
    if (thsPage.vars.advisor) {
      currentFilters.advisor = thsPage.vars.advisor;
    } else {
      currentFilters.advisor = '';
    }
    
    // Get checkbox state - if status is selected, set to false, otherwise use checkbox state
    const statusValue = U.id('statusDD').value;
    if (statusValue && statusValue !== '') {
      currentFilters.openApplicationsYN = false;
    } else {
      const checkboxEl = U.id('openApplicationsCheckbox');
      currentFilters.openApplicationsYN = checkboxEl ? checkboxEl.checked : true;
    }

    // Prepare the request body with filters and export_file parameter
    const body = {};
    body.filters = currentFilters;
    body.export_file = exportType; // 'page' or 'All'
    
    // If exporting current page, include pagination info
    if (exportType === 'page') {
      body.limit = 50;
      body.page = parseInt(thsPage.vars.selected_page);
    }

    try {
      // Get auth headers
      const hdrs = await O.getAuthHdrs();
      body.user_uuid = hdrs.user_uuid ? hdrs.user_uuid : '';
      
      // Create method object using the same pattern as mPOST
      const methodObj = await O.mPOST('application/app-list', body);
      
      // Make fetch call to handle blob response (same URL pattern as postMethod)
      const response = await fetch(methodObj.endPoint + methodObj.method, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${hdrs.token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      });

      if (!response.ok) {
        throw new Error(`Export failed: ${response.statusText}`);
      }

      // Try to get filename from Content-Disposition header
      // NOTE: This will be null if the server doesn't expose it via Access-Control-Expose-Headers
      let contentDisposition = null;
      try {
        contentDisposition = response.headers.get('Content-Disposition');
      } catch (e) {
        // Header not accessible due to CORS restrictions
      }
      
      let fileName = `applications_export_${exportType === 'page' ? 'page' : 'all'}`;
      
      if (contentDisposition) {
        // Extract filename from Content-Disposition header
        // Format: attachment; filename="applications_export2_all_2026_Jan_23_16_25.xlsx"
        const quotedMatch = contentDisposition.match(/filename\s*=\s*"([^"]+)"/i);
        if (quotedMatch && quotedMatch[1]) {
          fileName = quotedMatch[1].trim();
        } else {
          const unquotedMatch = contentDisposition.match(/filename\s*=\s*([^;\s]+)/i);
          if (unquotedMatch && unquotedMatch[1]) {
            fileName = unquotedMatch[1].trim();
          } else {
            const utf8Match = contentDisposition.match(/filename\*\s*=\s*UTF-8''([^;\s]+)/i);
            if (utf8Match && utf8Match[1]) {
              fileName = decodeURIComponent(utf8Match[1]).trim();
            }
          }
        }
      } else {
        // Content-Disposition header is not accessible due to CORS
        // Generate filename with timestamp as fallback
        const now = new Date();
        const dateStr = now.toISOString().slice(0, 19).replace(/:/g, '_').replace('T', '_');
        fileName = `applications_export_${exportType === 'page' ? 'page' : 'all'}_${dateStr}`;
      }
      
      // Ensure filename has .xlsx extension
      if (!fileName.toLowerCase().endsWith('.xlsx') && !fileName.toLowerCase().endsWith('.xls')) {
        fileName = fileName.replace(/\.(csv)?$/i, '') + '.xlsx';
      }

      // Get the blob from response
      const blob = await response.blob();
      
      // Create download link and trigger download
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (error) {
      comp.errorBox('Error', 'Failed to export applications. Please try again.');
    }
  },

  // Called when input text changes to render auto-suggest dropdown
  async getSuggestedOrganisations() {
    
    // Organisation input text element ref
    let orgInputTextEl = U.id('organisationDD');

    // If input text is empty, set value of dropdown to ""
    if (orgInputTextEl.value === '') {
      // Get list of applications after user clicks out of dropdown / input text
      this.getAppList();
    }

    // Remove existing organisation auto suggestion dropdown
    // Organisation auto-suggest dropdown element ref
    let orgListDropdownEl = U.id('orgListDropdown');
    if (orgListDropdownEl) {
      orgListDropdownEl.remove();
    }

    // Remove existing organisation branch auto suggestion dropdown
    // Organisation bbranch auto-suggest dropdown element ref
    let orgBranchListDropdownEl = U.id('orgBranchListDropdown');
    if (orgBranchListDropdownEl) {
      orgBranchListDropdownEl.remove();
    }

    clearTimeout(window.timeout);
    window.timeout = setTimeout(async () => {
      const filters = {};
      filters.search_filters = U.id('organisationDD').value.trim();

      const vars = {};
      vars.filters = filters;

      O.PREP([await O.mPOST('communal/organisations', vars)])
        .then(async (res) => {
          const orgListData = res['communal/organisations'].data;

          // Create datalist dropdown element
          const orgListDropdown = await comp.dataListDropdown({elID: 'orgListDropdown', ddData: orgListData, valueDataName: 'org_uuid', textDataName: 'long_text', requiredYN: 0, onselect: 'handleOrganisationSelection', className: 'orgSuggestionOption'});
          // Add datalist element underneath auto-suggest text input
          U.id('organisationDDDiv').appendChild(orgListDropdown);
        })
        .catch(() => {});
    }, 300);
  },

  // Called when input text changes to render auto-suggest dropdown
  async getSuggestedOrganisationBranches() {
    // Organisation branch input text element ref
    let orgBranchInputTextEl = U.id('organisationBranchDD');

    // If input text is empty, set value of dropdown to ""
    if (orgBranchInputTextEl.value === '') {
      // Get list of applications after user clicks out of dropdown / input text
      this.getAppList();
    }

    // Remove existing organisation auto suggestion dropdown
    // Organisation auto-suggest dropdown element ref
    let orgListDropdownEl = U.id('orgListDropdown');
    if (orgListDropdownEl) {
      orgListDropdownEl.remove();
    }

    // Remove existing organisation branch auto suggestion dropdown
    // Organisation branch auto-suggest dropdown element ref
    let orgBranchListDropdownEl = U.id('orgBranchListDropdown');
    if (orgBranchListDropdownEl) {
      orgBranchListDropdownEl.remove();
    }

    clearTimeout(window.timeout);
    window.timeout = setTimeout(async () => {
      const filters = {};
      filters.search_filters = U.id('organisationBranchDD').value.trim();

      const vars = {};
      vars.filters = filters;

      O.PREP([await O.mPOST('communal/org-branches', vars)])
        .then(async (res) => {
          const orgBranchListData = res['communal/org-branches'].data;

          // Create datalist dropdown element
          const orgBranchListDropdown = await comp.dataListDropdown({elID: 'orgBranchListDropdown', ddData: orgBranchListData, valueDataName: 'org_branch_uuid', textDataName: 'combo_text', requiredYN: 0, onselect: 'handleOrganisationBranchSelection', className: 'orgBranchSuggestionOption'});
          // Add datalist element underneath auto-suggest text input
          U.id('organisationBranchDDDiv').appendChild(orgBranchListDropdown);
        })
        .catch(() => {});
    }, 300);
  },

  // Called when input text changes to render auto-suggest dropdown
  async getSuggestedAdvisors() {
    // Advisor input text element ref
    let advisorInputTextEl = U.id('advisorDD');
    if (!advisorInputTextEl) return;

    // If input text is empty, set value of dropdown to ""
    if (advisorInputTextEl.value === '') {
      thsPage.vars.advisor = '';
      thsPage.vars.advisor_text = '';
      // Get list of applications after user clicks out of dropdown / input text
      this.getAppList();
    }

    // Remove existing advisor auto suggestion dropdown
    let advisorListDropdownEl = U.id('advisorListDropdown');
    if (advisorListDropdownEl) {
      advisorListDropdownEl.remove();
    }
    const advisorListDropdownContainer = U.id('advisorListDropdownContainer');
    if (advisorListDropdownContainer) {
      advisorListDropdownContainer.remove();
    }

    const query = advisorInputTextEl.value.trim();
    if (query.length < 3) return;

    const vars = {};
    vars.search_filter = query;

    try {
      const res = await O.PREP([await O.mPOST('communal/advisor-autosuggest', vars)]);
      const advisorListData = res['communal/advisor-autosuggest'].data;

      // Create datalist dropdown element
      const advisorListDropdown = await comp.dataListDropdown({
        elID: 'advisorListDropdown',
        ddData: advisorListData,
        valueDataName: 'user_uuid',
        textDataName: `combo_text`,
        requiredYN: 0,
        onselect: 'handleAdvisorSelection',
        className: 'advisorSuggestionOption',
      });
      // Add datalist element underneath auto-suggest text input
      U.id('advisorDDDiv').appendChild(advisorListDropdown);
    } catch (e) {}
  },

  async clearSearch() {
    const searchInps = document.querySelectorAll('.searchInputs');
    searchInps.forEach((inp) => {
      inp.value = '';
    });

    this.getAppList();
  },

  setupSearchInputEvents() {
    // Wait a bit for the DOM to be fully rendered
    setTimeout(() => {
      const genSearchEl = U.id('genSearch');
      
      if (genSearchEl) {
        // Add debounced search for genSearch input
        genSearchEl.addEventListener('keyup', (e) => {
          clearTimeout(window.timeout);
          window.timeout = setTimeout(() => {
            this.debouncedGetAppList(); // Use debounced version
          }, 1000); // 1 second delay
        });
        
        genSearchEl.addEventListener('input', (e) => {
          clearTimeout(window.timeout);
          window.timeout = setTimeout(() => {
            this.debouncedGetAppList(); // Use debounced version
          }, 1000);
        });
      }

      // Add debounced search for willNumberSearch input
      const willNumberSearchEl = U.id('willNumberSearch');
      if (willNumberSearchEl) {
        const syncNavRibbon = () => {
          const navEl = U.id('navRibbonInput');
          if (navEl) navEl.value = willNumberSearchEl.value;
          if (typeof window.updateNavRibbonClearBtn === 'function') window.updateNavRibbonClearBtn();
        };
        willNumberSearchEl.addEventListener('keyup', (e) => {
          syncNavRibbon();
          clearTimeout(window.timeout);
          window.timeout = setTimeout(() => {
            this.debouncedGetAppList();
          }, 1000);
        });
        willNumberSearchEl.addEventListener('input', (e) => {
          syncNavRibbon();
          clearTimeout(window.timeout);
          window.timeout = setTimeout(() => {
            this.debouncedGetAppList();
          }, 1000);
        });
      }
      
      // Add event listeners for auto-suggest inputs
      const organisationDD = U.id('organisationDD');
      if (organisationDD) {
        organisationDD.addEventListener('input', (e) => {
          clearTimeout(window.timeout);
          window.timeout = setTimeout(() => {
            this.getSuggestedOrganisations();
          }, 300);
        });
      }
      
      const organisationBranchDD = U.id('organisationBranchDD');
      if (organisationBranchDD) {
        organisationBranchDD.addEventListener('input', (e) => {
          clearTimeout(window.timeout);
          window.timeout = setTimeout(() => {
            this.getSuggestedOrganisationBranches();
          }, 300);
        });
      }
      
      const advisorDD = U.id('advisorDD');
      if (advisorDD) {
        advisorDD.addEventListener('input', (e) => {
          clearTimeout(window.timeout);
          const query = advisorDD.value.trim();
          if (query.length < 3) {
            const dropdown = U.id('advisorListDropdownContainer');
            if (dropdown) dropdown.remove();
            if (advisorDD.value === '') {
              thsPage.vars.advisor = '';
              thsPage.vars.advisor_text = '';
              this.getAppList();
            }
            return;
          }
          window.timeout = setTimeout(() => {
            this.getSuggestedAdvisors();
          }, 1000);
        });
      }
    }, 100); // Wait 100ms for DOM to be ready
  },

  // Handle organisation selection and close dropdown
  handleOrganisationSelection() {
    // Remove the dropdown
    const orgListDropdownEl = U.id('orgListDropdownContainer');
    if (orgListDropdownEl) {
      orgListDropdownEl.remove();
    }
    
    // Update the input field with the selected text
    if (thsPage.vars.organisation_text) {
      U.id('organisationDD').value = thsPage.vars.organisation_text;
    }
    
    // Call debounced getAppList to refresh the data
    this.debouncedGetAppList();
  },

  // Handle organisation branch selection and close dropdown
  handleOrganisationBranchSelection() {
    // Remove the dropdown
    const orgBranchListDropdownEl = U.id('orgBranchListDropdownContainer');
    if (orgBranchListDropdownEl) {
      orgBranchListDropdownEl.remove();
    }
    
    // Update the input field with the selected text
    if (thsPage.vars.organisation_branch_text) {
      U.id('organisationBranchDD').value = thsPage.vars.organisation_branch_text;
    }
    
    // Call debounced getAppList to refresh the data
    this.debouncedGetAppList();
  },

  // Handle advisor selection and close dropdown
  handleAdvisorSelection() {
    // Remove the dropdown
    const advisorListDropdownEl = U.id('advisorListDropdownContainer');
    if (advisorListDropdownEl) {
      advisorListDropdownEl.remove();
    }
    
    // Update the input field with the selected text
    if (thsPage.vars.advisor_text) {
      U.id('advisorDD').value = thsPage.vars.advisor_text;
    }
    
    // Call debounced getAppList to refresh the data
    this.debouncedGetAppList();
  },
};
